import { useTranslation } from 'react-i18next'

import type { SelectOption } from '@/components/Select/Select'
import { AsyncSelect } from '@/components/common/AsyncSelect'
import { roomsQueryOptions } from '@/queries/roomsQueryOptions'
import type { FormFieldType } from '@/types/form-field-type'

const PreferredRoomsSelect = (props: FormFieldType<SelectOption<string>[]>) => {
  const { t } = useTranslation('coursesManagement')

  return (
    <AsyncSelect
      {...props}
      multiple
      placeholder={t('placeholder.select-preferred-rooms')}
      queryOptions={roomsQueryOptions}
    />
  )
}

export default PreferredRoomsSelect
